import { useState, useEffect } from "react";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(()=>{}); });
}

// ── TABS ── (13 tabs: split Disney/Cruise, add Gatlinburg)
const TABS = [
  { id:"start",        label:"Start Here",    icon:"🏠", color:"#EA580C", light:"#FFF7ED" },
  { id:"flights",      label:"Flights",       icon:"✈️",  color:"#0284C7", light:"#E0F2FE" },
  { id:"lodging",      label:"Lodging",       icon:"🏨", color:"#16A34A", light:"#F0FDF4" },
  { id:"itinerary",    label:"Itinerary",     icon:"📅", color:"#7C3AED", light:"#F5F3FF" },
  { id:"budget",       label:"Budget",        icon:"💰", color:"#D97706", light:"#FFFBEB" },
  { id:"packing",      label:"Packing",       icon:"🧳", color:"#0D9488", light:"#F0FDFA" },
  { id:"emergency",    label:"Emergency",     icon:"🚨", color:"#E11D48", light:"#FFF1F2" },
  { id:"disney",       label:"Disney",        icon:"🏰", color:"#7C3AED", light:"#FAF5FF" },
  { id:"cruise",       label:"Cruise",        icon:"🚢", color:"#0369A1", light:"#E0F2FE" },
  { id:"gatlinburg",   label:"Gatlinburg",    icon:"⛰️", color:"#15803D", light:"#F0FDF4" },
  { id:"reservations", label:"Reservations",  icon:"📋", color:"#059669", light:"#ECFDF5" },
  { id:"dashboard",    label:"Dashboard",     icon:"📊", color:"#1E3A5F", light:"#F0F4FF" },
  { id:"tools",        label:"Travel Tools",  icon:"🛠️",  color:"#0369A1", light:"#F0F9FF" },
];

// ── BUDGET CATEGORIES (cleaned — no emoji duplicates)
const BUDGET_CATS = [
  "✈️ Flights","🏨 Lodging","🍽️ Dining","🎡 Activities & Parks",
  "🚗 Transportation","🛍️ Shopping","💊 Health & Pharmacy",
  "🎁 Souvenirs & Misc","📎 Other"
];
const BUDGET_CAT_COLORS = {
  "✈️ Flights":"#0284C7","🏨 Lodging":"#16A34A","🍽️ Dining":"#D97706",
  "🎡 Activities & Parks":"#7C3AED","🚗 Transportation":"#0891B2",
  "🛍️ Shopping":"#DB2777","💊 Health & Pharmacy":"#E11D48",
  "🎁 Souvenirs & Misc":"#EA580C","📎 Other":"#64748B"
};

// ── PACKING (added Curling Iron, Hair Straightener, Jewelry, Makeup)
const PACKING_CATS = {
  "👕 Clothing":        ["T-shirts","Shorts/Pants","Dress/Nice outfit","Underwear","Socks","Swimsuit","Pajamas","Jacket/Rain layer","Casual shoes","Nice shoes","Flip flops"],
  "🧴 Toiletries":      ["Toothbrush & toothpaste","Shampoo/Conditioner","Body wash","Deodorant","Sunscreen","Chapstick","Razor","Bug spray","Hand sanitizer","Medications","Curling iron","Hair straightener","Jewelry","Makeup"],
  "💻 Tech & Docs":     ["Phone + charger","Portable battery","Camera","Earbuds","Passports/IDs","Insurance cards","Confirmations printout","Wallet/cards","Travel adapter","Laptop/tablet"],
  "👶 Kids Essentials": ["Stroller","Car seat","Diapers & wipes","Snacks","Favorite toy","iPad + charger","Kids swimsuit","Kids sunscreen","Night light","Baby monitor"],
  "🎒 Carry-On":        ["Change of clothes","Snacks","Water bottle","Neck pillow","Eye mask","Sanitizing wipes","Headphones","Entertainment","Medications","Gum/mints"],
};

// ── DISNEY HEADLINERS for LL tracker
const LL_RIDES = {
  "Magic Kingdom": ["Tron Lightcycle Run","Seven Dwarfs Mine Train","Space Mountain","Big Thunder Mountain","Haunted Mansion","Peter Pan's Flight","TRON"],
  "EPCOT":         ["Guardians of the Galaxy","Test Track","Frozen Ever After","Remy's Ratatouille","Soarin'","Mission Space"],
  "Hollywood Studios": ["Star Wars: Rise of the Resistance","Slinky Dog Dash","Mickey & Minnie's Runaway Railway","Millennium Falcon","Tower of Terror","Rock 'n' Roller Coaster"],
  "Animal Kingdom": ["Avatar Flight of Passage","Na'vi River Journey","Expedition Everest","Kilimanjaro Safaris","DINOSAUR"],
};

// ── STYLES
const S = {
  card:  { background:"#fff", borderRadius:16, boxShadow:"0 2px 12px rgba(0,0,0,0.06)", padding:"20px 22px", marginBottom:16 },
  label: { display:"block", fontSize:11, fontWeight:700, color:"#64748b", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:5 },
  input: { width:"100%", border:"1.5px solid #e2e8f0", borderRadius:10, padding:"9px 13px", fontSize:14, fontFamily:"system-ui,sans-serif", color:"#1e293b", background:"#fafafa", outline:"none" },
  grid2: { display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:"0 20px" },
  grid3: { display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(190px,1fr))", gap:"0 16px" },
};

// ── SHARED UI
const Field = ({ label, children }) => (
  <div style={{ marginBottom:14 }}><label style={S.label}>{label}</label>{children}</div>
);
const Inp = ({ value, onChange, placeholder, type="text", style={} }) => (
  <input type={type} value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder} style={{...S.input,...style}} />
);
const Sel = ({ value, onChange, options, style={} }) => (
  <select value={value||""} onChange={e=>onChange(e.target.value)} style={{...S.input,cursor:"pointer",...style}}>
    {options.map(o=><option key={typeof o==="string"?o:o.value} value={typeof o==="string"?o:o.value}>{typeof o==="string"?o:o.label}</option>)}
  </select>
);
const Banner = ({ icon, title, subtitle, color, onPrint }) => (
  <div style={{ background:`linear-gradient(135deg,#1e3a5f 0%,${color} 100%)`, borderRadius:16, padding:"20px 26px", marginBottom:20, boxShadow:`0 4px 20px ${color}44`, display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
    <div>
      <div style={{ fontSize:26, marginBottom:3 }}>{icon}</div>
      <div style={{ color:"#fff", fontWeight:800, fontSize:22 }}>{title}</div>
      {subtitle && <div style={{ color:"rgba(255,255,255,0.75)", fontSize:13, marginTop:3 }}>{subtitle}</div>}
    </div>
    <button onClick={onPrint||window.print} style={{ background:"rgba(255,255,255,0.18)", color:"#fff", border:"1px solid rgba(255,255,255,0.35)", borderRadius:8, padding:"7px 16px", fontSize:12, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", gap:6 }}>
      🖨️ Print Tab
    </button>
  </div>
);
const Badge = ({ text, color }) => (
  <span style={{ background:color+"18", color, border:`1px solid ${color}33`, borderRadius:99, padding:"3px 11px", fontSize:11, fontWeight:700 }}>{text}</span>
);
const Btn = ({ onClick, color, children, style={} }) => (
  <button onClick={onClick} style={{ background:color, color:"#fff", border:"none", borderRadius:10, padding:"9px 20px", fontWeight:700, fontSize:13, cursor:"pointer", fontFamily:"system-ui,sans-serif", ...style }}>{children}</button>
);
const RemBtn = ({ onClick }) => (
  <button onClick={onClick} style={{ background:"none", border:"none", color:"#e11d48", cursor:"pointer", fontSize:18, padding:"2px 6px" }}>✕</button>
);
const SecHead = ({ title, color }) => (
  <div style={{ background:color, color:"#fff", borderRadius:10, padding:"7px 15px", fontWeight:800, fontSize:12, letterSpacing:"0.05em", textTransform:"uppercase", marginBottom:14, display:"inline-block" }}>{title}</div>
);
const SyncNote = ({ color }) => (
  <div style={{ background:color+"12", border:`1px solid ${color}33`, borderRadius:10, padding:"8px 14px", marginBottom:14, fontSize:12, color, fontWeight:600, display:"flex", alignItems:"center", gap:8 }}>
    💡 Costs entered here automatically appear in your Budget & Dashboard tabs
  </div>
);
const Copyright = () => (
  <div style={{ textAlign:"center", padding:"20px 0 6px", color:"#cbd5e1", fontSize:11, borderTop:"1px solid #f1f5f9", marginTop:28 }}>
    © 2026 Thoroughbred Vacations™ · Family Travel Command Center · thoroughbredvacations.com
  </div>
);
const CheckRow = ({ label, checked, onToggle, color="#0284C7" }) => (
  <div onClick={onToggle} style={{ display:"flex", alignItems:"center", gap:10, padding:"7px 6px", cursor:"pointer", borderBottom:"1px solid #f8fafc", borderRadius:6 }}>
    <div style={{ width:20, height:20, borderRadius:5, flexShrink:0, border:`2px solid ${checked?color:"#cbd5e1"}`, background:checked?color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.15s" }}>
      {checked && <span style={{ color:"#fff", fontSize:12, fontWeight:900 }}>✓</span>}
    </div>
    <span style={{ fontSize:13, color:checked?"#94a3b8":"#374151", textDecoration:checked?"line-through":"none" }}>{label}</span>
  </div>
);

// ── HELPERS
const bagCalc   = f => (parseFloat(f.bags)||0) * (parseFloat(f.bagFee)||0);
const nightCalc = h => (!h.checkIn||!h.checkOut) ? 0 : Math.max(0,Math.ceil((new Date(h.checkOut)-new Date(h.checkIn))/86400000));

// ══════════════════════════════════════════════════
// START HERE
// ══════════════════════════════════════════════════
function StartHere({ trip, setTrip }) {
  const t = TABS.find(t=>t.id==="start");
  const u = (k,v) => setTrip(p=>({...p,[k]:v}));
  return (
    <div>
      <Banner icon="🏠" title="Start Here" subtitle="Fill in your trip details to get started — everything flows from this tab" color={t.color} />
      <div style={S.card}>
        <SecHead title="Trip Information" color={t.color} />
        <div style={S.grid2}>
          <Field label="Trip Name"><Inp value={trip.name} onChange={v=>u("name",v)} placeholder="e.g. Disney World 2026" /></Field>
          <Field label="Destination"><Inp value={trip.destination} onChange={v=>u("destination",v)} placeholder="e.g. Orlando, FL" /></Field>
          <Field label="Start Date"><Inp type="date" value={trip.startDate} onChange={v=>u("startDate",v)} /></Field>
          <Field label="End Date"><Inp type="date" value={trip.endDate} onChange={v=>u("endDate",v)} /></Field>
          <Field label="Number of Travelers"><Inp type="number" value={trip.travelers} onChange={v=>u("travelers",v)} placeholder="4" /></Field>
          <Field label="Trip Type / Theme"><Inp value={trip.tripType} onChange={v=>u("tripType",v)} placeholder="Beach vacation, Disney, Cruise, Road trip..." /></Field>
          <Field label="Total Budget Goal ($)"><Inp type="number" value={trip.budgetGoal} onChange={v=>u("budgetGoal",v)} placeholder="5000" /></Field>
        </div>
        <Field label="Trip Notes"><Inp value={trip.notes} onChange={v=>u("notes",v)} placeholder="Special reminders, ideas, must-dos..." /></Field>
      </div>
      <div style={{...S.card, background:"#FFF7ED", border:"1.5px solid #fed7aa"}}>
        <div style={{ fontWeight:800, color:t.color, marginBottom:12, fontSize:15 }}>📖 How To Use This App</div>
        {[
          ["✈️ Flights",        "Log every flight leg — ticket costs + bag fees auto-sync to Budget."],
          ["🏨 Lodging",        "Add hotels/rentals — nightly rate × nights auto-syncs to Budget."],
          ["📅 Itinerary",      "Plan day-by-day activities — activity costs auto-sync to Budget."],
          ["💰 Budget",         "See auto-populated costs. Add dining, shopping & other expenses."],
          ["🧳 Packing",        "Check off every item as you pack — progress bar tracks completion."],
          ["🚨 Emergency",      "Store medical info, insurance, and emergency contacts."],
          ["🏰 Disney",         "Disney park planner with Lightning Lane tracker & must-do rides."],
          ["🚢 Cruise",         "Cruise planner with embarkation checklist & port excursions."],
          ["⛰️ Gatlinburg",     "Cabin info, Dollywood planner, hiking tracker & restaurant list."],
          ["📋 Reservations",   "Track all dining, entertainment and activity bookings."],
          ["📊 Dashboard",      "Full trip summary — all costs, bookings and stats in one view."],
          ["🛠️ Travel Tools",   "Weather forecast, currency converter & affiliate travel deals."],
        ].map(([tab,desc])=>(
          <div key={tab} style={{ display:"flex", gap:12, padding:"7px 0", borderBottom:"1px solid #fed7aa55", fontSize:14 }}>
            <span style={{ fontWeight:700, color:t.color, minWidth:150 }}>{tab}</span>
            <span style={{ color:"#78350f" }}>{desc}</span>
          </div>
        ))}
      </div>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// FLIGHTS
// ══════════════════════════════════════════════════
function Flights({ flights, setFlights }) {
  const t = TABS.find(t=>t.id==="flights");
  const add = () => setFlights(f=>[...f,{ id:Date.now(), route:"", airline:"", flightNo:"", depart:"", departDate:"", departTime:"", arrive:"", arriveDate:"", arriveTime:"", confirmation:"", seats:"", bags:"", bagFee:"", cost:"", notes:"" }]);
  const upd = (id,k,v) => setFlights(f=>f.map(r=>r.id===id?{...r,[k]:v}:r));
  const rem = id => setFlights(f=>f.filter(r=>r.id!==id));
  const totalBags = flights.reduce((s,f)=>s+bagCalc(f),0);
  const totalCost = flights.reduce((s,f)=>s+(parseFloat(f.cost)||0),0);
  return (
    <div>
      <Banner icon={t.icon} title="Flights" subtitle="Log every flight leg — costs auto-sync to Budget & Dashboard" color={t.color} />
      <SyncNote color={t.color} />
      {flights.map((fl,i)=>(
        <div key={fl.id} style={S.card}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
            <Badge text={`LEG ${i+1}`} color={t.color} />
            <div style={{ display:"flex", alignItems:"center", gap:12 }}>
              {(parseFloat(fl.cost)||bagCalc(fl))>0 && <Badge text={`Total: $${((parseFloat(fl.cost)||0)+bagCalc(fl)).toFixed(2)}`} color={t.color} />}
              <RemBtn onClick={()=>rem(fl.id)} />
            </div>
          </div>
          <div style={S.grid3}>
            <Field label="Route (e.g. CVG → MCO)"><Inp value={fl.route} onChange={v=>upd(fl.id,"route",v)} placeholder="CVG → MCO (Outbound)" /></Field>
            <Field label="Airline"><Inp value={fl.airline} onChange={v=>upd(fl.id,"airline",v)} placeholder="Delta" /></Field>
            <Field label="Flight #"><Inp value={fl.flightNo} onChange={v=>upd(fl.id,"flightNo",v)} placeholder="DL1234" /></Field>
            <Field label="Depart Airport"><Inp value={fl.depart} onChange={v=>upd(fl.id,"depart",v)} placeholder="CVG" /></Field>
            <Field label="Depart Date"><Inp type="date" value={fl.departDate} onChange={v=>upd(fl.id,"departDate",v)} /></Field>
            <Field label="Depart Time"><Inp type="time" value={fl.departTime} onChange={v=>upd(fl.id,"departTime",v)} /></Field>
            <Field label="Arrive Airport"><Inp value={fl.arrive} onChange={v=>upd(fl.id,"arrive",v)} placeholder="MCO" /></Field>
            <Field label="Arrive Date"><Inp type="date" value={fl.arriveDate} onChange={v=>upd(fl.id,"arriveDate",v)} /></Field>
            <Field label="Arrive Time"><Inp type="time" value={fl.arriveTime} onChange={v=>upd(fl.id,"arriveTime",v)} /></Field>
            <Field label="Confirmation #"><Inp value={fl.confirmation} onChange={v=>upd(fl.id,"confirmation",v)} placeholder="ABC123" /></Field>
            <Field label="Seat(s)"><Inp value={fl.seats} onChange={v=>upd(fl.id,"seats",v)} placeholder="12A, 12B" /></Field>
            <Field label="Ticket Cost ($)"><Inp type="number" value={fl.cost} onChange={v=>upd(fl.id,"cost",v)} placeholder="0.00" /></Field>
            <Field label="# Checked Bags"><Inp type="number" value={fl.bags} onChange={v=>upd(fl.id,"bags",v)} placeholder="2" /></Field>
            <Field label="Fee Per Bag ($)"><Inp type="number" value={fl.bagFee} onChange={v=>upd(fl.id,"bagFee",v)} placeholder="45.00" /></Field>
            <Field label="Bag Total">
              <div style={{...S.input,background:"#f0f9ff",color:"#0284C7",fontWeight:700}}>
                ${bagCalc(fl).toFixed(2)} {fl.bags&&fl.bagFee?`(${fl.bags} × $${fl.bagFee})`:""}
              </div>
            </Field>
          </div>
          <Field label="Notes"><Inp value={fl.notes} onChange={v=>upd(fl.id,"notes",v)} placeholder="TSA Pre, online check-in reminder, gate info..." /></Field>
        </div>
      ))}
      {flights.length>0 && (
        <div style={{...S.card, display:"flex", justifyContent:"flex-end", gap:24, background:"#E0F2FE", marginBottom:16}}>
          <span style={{ fontWeight:700, color:t.color }}>All Bag Fees: <strong>${totalBags.toFixed(2)}</strong></span>
          <span style={{ fontWeight:700, color:t.color }}>All Tickets: <strong>${totalCost.toFixed(2)}</strong></span>
          <span style={{ fontWeight:800, color:"#1e3a5f" }}>Grand Total: <strong>${(totalBags+totalCost).toFixed(2)}</strong></span>
        </div>
      )}
      <Btn onClick={add} color={t.color}>+ Add Flight Leg</Btn>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// LODGING
// ══════════════════════════════════════════════════
function Lodging({ lodging, setLodging }) {
  const t = TABS.find(t=>t.id==="lodging");
  const add = () => setLodging(l=>[...l,{ id:Date.now(), name:"", type:"Hotel", address:"", checkIn:"", checkOut:"", confirmNo:"", phone:"", roomType:"", guests:"", parking:"No", breakfast:"No", nightly:"", notes:"" }]);
  const upd = (id,k,v) => setLodging(l=>l.map(r=>r.id===id?{...r,[k]:v}:r));
  const rem = id => setLodging(l=>l.filter(r=>r.id!==id));
  const total = lodging.reduce((s,h)=>s+nightCalc(h)*(parseFloat(h.nightly)||0),0);
  return (
    <div>
      <Banner icon={t.icon} title="Lodging" subtitle="Hotels & rentals — nightly rate × nights auto-syncs to Budget" color={t.color} />
      <SyncNote color={t.color} />
      {lodging.map((h,i)=>{
        const n=nightCalc(h), stayTotal=n*(parseFloat(h.nightly)||0);
        return (
          <div key={h.id} style={S.card}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
              <Badge text={`STAY ${i+1}`} color={t.color} />
              <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                {n>0&&<Badge text={`${n} nights — $${stayTotal.toFixed(2)}`} color={t.color} />}
                <RemBtn onClick={()=>rem(h.id)} />
              </div>
            </div>
            <div style={S.grid3}>
              <Field label="Property Name"><Inp value={h.name} onChange={v=>upd(h.id,"name",v)} placeholder="Disney's Beach Club" /></Field>
              <Field label="Type"><Sel value={h.type} onChange={v=>upd(h.id,"type",v)} options={["Hotel","Vacation Rental","Airbnb","Resort","Motel","Campsite","Cabin","Other"]} /></Field>
              <Field label="Address / City"><Inp value={h.address} onChange={v=>upd(h.id,"address",v)} placeholder="Orlando, FL" /></Field>
              <Field label="Check-In Date"><Inp type="date" value={h.checkIn} onChange={v=>upd(h.id,"checkIn",v)} /></Field>
              <Field label="Check-Out Date"><Inp type="date" value={h.checkOut} onChange={v=>upd(h.id,"checkOut",v)} /></Field>
              <Field label="Nights Auto-Calculated">
                <div style={{...S.input,background:"#f0fdf4",color:"#16A34A",fontWeight:700}}>
                  {n>0?`${n} nights`:"Enter check-in & out dates"}
                </div>
              </Field>
              <Field label="Confirmation #"><Inp value={h.confirmNo} onChange={v=>upd(h.id,"confirmNo",v)} placeholder="ABC123456" /></Field>
              <Field label="Phone"><Inp value={h.phone} onChange={v=>upd(h.id,"phone",v)} placeholder="(407) 000-0000" /></Field>
              <Field label="Room Type"><Inp value={h.roomType} onChange={v=>upd(h.id,"roomType",v)} placeholder="King Suite" /></Field>
              <Field label="# Guests"><Inp type="number" value={h.guests} onChange={v=>upd(h.id,"guests",v)} placeholder="4" /></Field>
              <Field label="Parking"><Sel value={h.parking} onChange={v=>upd(h.id,"parking",v)} options={["No","Free","Paid","Valet"]} /></Field>
              <Field label="Breakfast Included"><Sel value={h.breakfast} onChange={v=>upd(h.id,"breakfast",v)} options={["No","Yes","Continental","Full"]} /></Field>
              <Field label="Nightly Rate ($)"><Inp type="number" value={h.nightly} onChange={v=>upd(h.id,"nightly",v)} placeholder="0.00" /></Field>
              <Field label="Stay Total Auto-Calculated">
                <div style={{...S.input,background:"#f0fdf4",color:"#16A34A",fontWeight:700}}>
                  ${stayTotal.toFixed(2)} {n>0&&h.nightly?`(${n} × $${h.nightly})`:""}
                </div>
              </Field>
            </div>
            <Field label="Notes"><Inp value={h.notes} onChange={v=>upd(h.id,"notes",v)} placeholder="Pool, free Wi-Fi, pet friendly..." /></Field>
          </div>
        );
      })}
      {lodging.length>0&&(
        <div style={{...S.card,display:"flex",justifyContent:"flex-end",background:"#F0FDF4",marginBottom:16}}>
          <span style={{ fontWeight:800, color:t.color }}>Total Lodging: <strong>${total.toFixed(2)}</strong></span>
        </div>
      )}
      <Btn onClick={add} color={t.color}>+ Add Hotel / Rental</Btn>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// ITINERARY
// ══════════════════════════════════════════════════
function Itinerary({ itinerary, setItinerary }) {
  const t = TABS.find(t=>t.id==="itinerary");
  const [form,setForm] = useState({ date:"", time:"8:00 AM", activity:"", location:"", notes:"", cost:"", status:"Planned" });
  const times = ["6:00 AM","7:00 AM","8:00 AM","9:00 AM","10:00 AM","11:00 AM","12:00 PM","1:00 PM","2:00 PM","3:00 PM","4:00 PM","5:00 PM","6:00 PM","7:00 PM","8:00 PM","9:00 PM"];
  const statusColors = { Planned:"#7C3AED", Confirmed:"#16A34A", Completed:"#64748b", Cancelled:"#E11D48" };
  const add = () => { if(!form.activity)return; setItinerary(it=>[...it,{...form,id:Date.now()}]); setForm(f=>({...f,activity:"",location:"",notes:"",cost:""})); };
  const rem = id => setItinerary(it=>it.filter(r=>r.id!==id));
  const cycleStatus = id => { const order=["Planned","Confirmed","Completed","Cancelled"]; setItinerary(it=>it.map(r=>r.id===id?{...r,status:order[(order.indexOf(r.status)+1)%order.length]}:r)); };
  const sorted = [...itinerary].sort((a,b)=>a.date!==b.date?a.date.localeCompare(b.date):times.indexOf(a.time)-times.indexOf(b.time));
  const byDay = sorted.reduce((acc,item)=>{ const k=item.date||"No Date"; if(!acc[k])acc[k]=[]; acc[k].push(item); return acc; },{});
  const totalCost = itinerary.reduce((s,i)=>s+(parseFloat(i.cost)||0),0);
  return (
    <div>
      <Banner icon={t.icon} title="Itinerary" subtitle="Day-by-day plan — activity costs auto-sync to Budget" color={t.color} />
      <SyncNote color={t.color} />
      <div style={S.card}>
        <SecHead title="Add Activity" color={t.color} />
        <div style={S.grid3}>
          <Field label="Date"><Inp type="date" value={form.date} onChange={v=>setForm(f=>({...f,date:v}))} /></Field>
          <Field label="Time"><Sel value={form.time} onChange={v=>setForm(f=>({...f,time:v}))} options={times} /></Field>
          <Field label="Status"><Sel value={form.status} onChange={v=>setForm(f=>({...f,status:v}))} options={["Planned","Confirmed","Completed","Cancelled"]} /></Field>
          <Field label="Activity / Event"><Inp value={form.activity} onChange={v=>setForm(f=>({...f,activity:v}))} placeholder="e.g. Magic Kingdom" /></Field>
          <Field label="Location / Venue"><Inp value={form.location} onChange={v=>setForm(f=>({...f,location:v}))} placeholder="e.g. Main Entrance" /></Field>
          <Field label="Est. Cost ($)"><Inp type="number" value={form.cost} onChange={v=>setForm(f=>({...f,cost:v}))} placeholder="0.00" /></Field>
        </div>
        <Field label="Notes / Reminders"><Inp value={form.notes} onChange={v=>setForm(f=>({...f,notes:v}))} placeholder="FastPass needed, reservation time, parking info..." /></Field>
        <Btn onClick={add} color={t.color}>+ Add to Itinerary</Btn>
      </div>
      {itinerary.length>0&&(
        <div style={{...S.card,background:"#F5F3FF",border:"1px solid #ede9fe",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{ fontWeight:700, color:t.color }}>{itinerary.length} activities planned</span>
          <span style={{ fontWeight:800, color:t.color }}>Total Activity Cost: ${totalCost.toFixed(2)}</span>
        </div>
      )}
      {Object.entries(byDay).map(([day,dayItems])=>(
        <div key={day} style={{ marginBottom:20 }}>
          <div style={{ fontWeight:800, fontSize:15, color:t.color, marginBottom:10, display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ background:t.color, color:"#fff", borderRadius:8, padding:"4px 12px", fontSize:13 }}>
              {day!=="No Date"?new Date(day+"T12:00:00").toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric"}):"No Date Set"}
            </div>
            <Badge text={`${dayItems.length} activities`} color={t.color} />
            <Badge text={`$${dayItems.reduce((s,i)=>s+(parseFloat(i.cost)||0),0).toFixed(2)}`} color={t.color} />
          </div>
          {dayItems.map(item=>(
            <div key={item.id} style={{ display:"flex", alignItems:"center", gap:12, background:"#fff", borderRadius:12, padding:"12px 16px", marginBottom:8, boxShadow:"0 1px 6px rgba(0,0,0,0.05)", borderLeft:`3px solid ${statusColors[item.status]||t.color}` }}>
              <div style={{ background:t.color+"15", color:t.color, borderRadius:8, padding:"5px 10px", fontWeight:800, fontSize:12, minWidth:72, textAlign:"center" }}>{item.time}</div>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, fontSize:14 }}>{item.activity}</div>
                <div style={{ color:"#64748b", fontSize:12, marginTop:2 }}>{[item.location,item.notes].filter(Boolean).join(" — ")}</div>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                {item.cost&&<Badge text={`$${parseFloat(item.cost).toFixed(2)}`} color={t.color} />}
                <span onClick={()=>cycleStatus(item.id)} style={{ background:statusColors[item.status]+"18", color:statusColors[item.status], border:`1px solid ${statusColors[item.status]}33`, borderRadius:99, padding:"3px 10px", fontSize:11, fontWeight:700, cursor:"pointer" }}>{item.status}</span>
                <RemBtn onClick={()=>rem(item.id)} />
              </div>
            </div>
          ))}
        </div>
      ))}
      {itinerary.length===0&&<div style={{ textAlign:"center", padding:"40px 20px", color:"#94a3b8" }}>No activities yet — add your first one above!</div>}
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// BUDGET (unique colors per category)
// ══════════════════════════════════════════════════
function Budget({ budget, setBudget, autoAmounts }) {
  const t = TABS.find(t=>t.id==="budget");
  const upd = (cat,field,val) => setBudget(b=>({...b,[cat]:{...b[cat],[field]:val}}));
  const totalPlanned = BUDGET_CATS.reduce((s,c)=>s+(parseFloat(budget[c]?.planned)||0),0);
  const totalActual  = BUDGET_CATS.reduce((s,c)=>s+(parseFloat(budget[c]?.actual)||0),0);
  const remaining    = totalPlanned - totalActual;
  return (
    <div>
      <Banner icon={t.icon} title="Budget Tracker" subtitle="Flight, lodging & activity costs auto-populate from other tabs" color={t.color} />
      <div style={{...S.card,background:"#FFFBEB",border:"1.5px solid #fde68a"}}>
        <div style={{ fontWeight:800, color:t.color, marginBottom:10, fontSize:13 }}>🔄 Auto-Populated from Other Tabs</div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10 }}>
          {[["✈️ Flights (tickets + bags)",autoAmounts.flights,"#0284C7"],["🏨 Lodging (nights × rate)",autoAmounts.lodging,"#16A34A"],["🎡 Activities (itinerary total)",autoAmounts.activities,"#7C3AED"]].map(([label,amt,color])=>(
            <div key={label} style={{ background:"#fff", borderRadius:10, padding:"12px 14px", border:`1px solid ${color}22` }}>
              <div style={{ fontSize:11, fontWeight:700, color:"#64748b", marginBottom:4 }}>{label}</div>
              <div style={{ fontSize:20, fontWeight:900, color }}>${amt.toFixed(2)}</div>
              <div style={{ fontSize:10, color:"#94a3b8", marginTop:2 }}>auto-calculated — read only</div>
            </div>
          ))}
        </div>
      </div>
      {totalPlanned>0&&(
        <div style={{...S.card,marginBottom:16}}>
          <div style={{ fontWeight:700, marginBottom:8, fontSize:13, color:"#64748b" }}>OVERALL BUDGET PROGRESS</div>
          <div style={{ background:"#e2e8f0", borderRadius:99, height:18, overflow:"hidden", marginBottom:8 }}>
            <div style={{ width:`${Math.min(100,(totalActual/totalPlanned)*100)}%`, background:totalActual>totalPlanned?"#DC2626":t.color, height:"100%", borderRadius:99, transition:"width 0.4s" }} />
          </div>
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:13 }}>
            <span style={{ color:"#64748b" }}>${totalActual.toFixed(2)} spent</span>
            <span style={{ fontWeight:800, color:remaining>=0?"#16A34A":"#DC2626" }}>
              {remaining>=0?`$${remaining.toFixed(2)} remaining`:`$${Math.abs(remaining).toFixed(2)} over budget`}
            </span>
            <span style={{ color:"#64748b" }}>${totalPlanned.toFixed(2)} budgeted</span>
          </div>
        </div>
      )}
      <div style={S.card}>
        <SecHead title="Category Breakdown" color={t.color} />
        <div style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
            <thead>
              <tr style={{ background:"#f8fafc" }}>
                {["Category","Auto-Calc","Planned ($)","Actual ($)","Difference","Progress","Notes"].map(h=>(
                  <th key={h} style={{ padding:"8px 12px", textAlign:"left", fontWeight:700, color:"#64748b", fontSize:11, textTransform:"uppercase", letterSpacing:"0.05em", whiteSpace:"nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {BUDGET_CATS.map((cat)=>{
                const color  = BUDGET_CAT_COLORS[cat]||t.color;
                const planned= parseFloat(budget[cat]?.planned)||0;
                const actual = parseFloat(budget[cat]?.actual)||0;
                const auto   = autoAmounts.byCat[cat]||0;
                const diff   = planned - actual;
                const pct    = planned>0?(actual/planned)*100:0;
                return (
                  <tr key={cat} style={{ borderBottom:"1px solid #f1f5f9" }}>
                    <td style={{ padding:"8px 12px", fontWeight:700, whiteSpace:"nowrap" }}>
                      <span style={{ background:color+"18", color, border:`1px solid ${color}33`, borderRadius:6, padding:"3px 10px", fontSize:12 }}>{cat}</span>
                    </td>
                    <td style={{ padding:"8px 12px", fontWeight:700, color:auto>0?"#059669":"#cbd5e1" }}>
                      {auto>0?`$${auto.toFixed(2)}`:"-"}
                      {auto>0&&<div style={{ fontSize:9, color:"#059669" }}>auto</div>}
                    </td>
                    <td style={{ padding:"4px 8px" }}>
                      <input type="number" value={budget[cat]?.planned||""} onChange={e=>upd(cat,"planned",e.target.value)} placeholder={auto>0?auto.toFixed(2):"0.00"} style={{...S.input,width:90,textAlign:"right"}} />
                    </td>
                    <td style={{ padding:"4px 8px" }}>
                      <input type="number" value={budget[cat]?.actual||""} onChange={e=>upd(cat,"actual",e.target.value)} placeholder="0.00" style={{...S.input,width:90,textAlign:"right"}} />
                    </td>
                    <td style={{ padding:"8px 12px", fontWeight:700, color:(planned||actual)?(diff>=0?"#16A34A":"#DC2626"):"#94a3b8", whiteSpace:"nowrap" }}>
                      {(planned||actual)?`${diff>=0?"+":""}$${diff.toFixed(2)}`:"-"}
                    </td>
                    <td style={{ padding:"8px 12px", minWidth:90 }}>
                      {planned>0?(<div>
                        <div style={{ background:"#e2e8f0", borderRadius:99, height:6, overflow:"hidden", marginBottom:2 }}><div style={{ width:`${Math.min(100,pct)}%`, background:pct>100?"#DC2626":color, height:"100%", borderRadius:99 }} /></div>
                        <div style={{ fontSize:10, color:"#64748b" }}>{pct.toFixed(1)}%</div>
                      </div>):"-"}
                    </td>
                    <td style={{ padding:"4px 8px" }}>
                      <input value={budget[cat]?.notes||""} onChange={e=>upd(cat,"notes",e.target.value)} style={{...S.input,minWidth:120}} placeholder="notes..." />
                    </td>
                  </tr>
                );
              })}
              <tr style={{ background:"#1e3a5f" }}>
                <td style={{ padding:"10px 12px", color:"#fff", fontWeight:800 }}>TOTAL</td>
                <td style={{ padding:"10px 12px", color:"#86efac", fontWeight:800 }}>${Object.values(autoAmounts.byCat).reduce((s,v)=>s+v,0).toFixed(2)}</td>
                <td style={{ padding:"10px 12px", color:"#fff", fontWeight:800 }}>${totalPlanned.toFixed(2)}</td>
                <td style={{ padding:"10px 12px", color:"#fff", fontWeight:800 }}>${totalActual.toFixed(2)}</td>
                <td style={{ padding:"10px 12px", fontWeight:800, color:remaining>=0?"#86efac":"#fca5a5" }}>${remaining.toFixed(2)}</td>
                <td colSpan={2} style={{ padding:"10px 12px", color:"#93c5fd", fontSize:12 }}>
                  {totalPlanned>0?`${((totalActual/totalPlanned)*100).toFixed(1)}% of budget used`:""}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// PACKING
// ══════════════════════════════════════════════════
function Packing({ packing, setPacking }) {
  const t = TABS.find(t=>t.id==="packing");
  const toggle = (cat,item) => setPacking(p=>{ const k=`${cat}__${item}`; return {...p,[k]:!p[k]}; });
  const allItems   = Object.values(PACKING_CATS).flat();
  const checkedCnt = Object.entries(PACKING_CATS).reduce((s,[cat,items])=>s+items.filter(i=>packing[`${cat}__${i}`]).length,0);
  const pct = Math.round((checkedCnt/allItems.length)*100);
  const catColors = [t.color,"#0284C7","#E11D48","#7C3AED","#D97706"];
  return (
    <div>
      <Banner icon={t.icon} title="Packing Checklist" subtitle="Check off every item before you leave home" color={t.color} />
      <div style={{...S.card,marginBottom:20}}>
        <div style={{ display:"flex", alignItems:"center", gap:16 }}>
          <div style={{ flex:1 }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
              <span style={{ fontWeight:700 }}>Packing Progress</span>
              <span style={{ fontWeight:800, color:t.color }}>{checkedCnt} / {allItems.length} items</span>
            </div>
            <div style={{ background:"#e2e8f0", borderRadius:99, height:14, overflow:"hidden" }}>
              <div style={{ width:`${pct}%`, background:pct===100?"#16A34A":t.color, height:"100%", borderRadius:99, transition:"width 0.3s" }} />
            </div>
          </div>
          <div style={{ fontSize:28, fontWeight:900, color:pct===100?"#16A34A":t.color, minWidth:55, textAlign:"center" }}>{pct}%</div>
        </div>
        {pct===100&&<div style={{ textAlign:"center", marginTop:10, color:"#16A34A", fontWeight:700 }}>🎉 All packed! Have an amazing trip!</div>}
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
        {Object.entries(PACKING_CATS).map(([cat,items],ci)=>{
          const checked=items.filter(i=>packing[`${cat}__${i}`]).length;
          const cc=catColors[ci%catColors.length];
          return (
            <div key={cat} style={{...S.card,marginBottom:0}}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
                <div style={{ fontWeight:800, color:cc, fontSize:14 }}>{cat}</div>
                <Badge text={`${checked}/${items.length}`} color={cc} />
              </div>
              {items.map(item=>{
                const isChecked=!!packing[`${cat}__${item}`];
                return (
                  <div key={item} onClick={()=>toggle(cat,item)} style={{ display:"flex", alignItems:"center", gap:10, padding:"6px 4px", cursor:"pointer", borderBottom:"1px solid #f1f5f9", borderRadius:6 }}>
                    <div style={{ width:20, height:20, borderRadius:6, flexShrink:0, border:`2px solid ${isChecked?cc:"#cbd5e1"}`, background:isChecked?cc:"#fff", display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.15s" }}>
                      {isChecked&&<span style={{ color:"#fff", fontSize:12, fontWeight:900 }}>✓</span>}
                    </div>
                    <span style={{ fontSize:13, color:isChecked?"#94a3b8":"#374151", textDecoration:isChecked?"line-through":"none" }}>{item}</span>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// EMERGENCY
// ══════════════════════════════════════════════════
function Emergency({ emergency, setEmergency, contacts, setContacts }) {
  const t = TABS.find(t=>t.id==="emergency");
  const u = (k,v) => setEmergency(e=>({...e,[k]:v}));
  const addC = () => setContacts(c=>[...c,{id:Date.now(),name:"",relation:"",cell:"",home:"",email:""}]);
  const updC = (id,k,v) => setContacts(c=>c.map(r=>r.id===id?{...r,[k]:v}:r));
  const remC = id => setContacts(c=>c.filter(r=>r.id!==id));
  return (
    <div>
      <Banner icon={t.icon} title="Emergency Information" subtitle="Print this and keep a copy in your carry-on bag" color={t.color} />
      <div style={{...S.card,borderLeft:`4px solid ${t.color}`}}>
        <SecHead title="Medical & Insurance" color={t.color} />
        <div style={S.grid2}>
          {[["insuranceProvider","Insurance Provider"],["policyNumber","Policy Number"],["insurancePhone","Insurance Phone"],["doctorName","Primary Doctor"],["doctorPhone","Doctor Phone"],["allergies","Allergies"],["bloodType","Blood Type"],["medications","Medications"],["conditions","Medical Conditions"],["travelInsurance","Travel Insurance 24hr Line"]].map(([k,l])=>(
            <Field key={k} label={l}><Inp value={emergency[k]} onChange={v=>u(k,v)} /></Field>
          ))}
        </div>
      </div>
      <div style={S.card}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
          <SecHead title="Emergency Contacts" color="#DC2626" />
          <Btn onClick={addC} color="#DC2626">+ Add Contact</Btn>
        </div>
        {contacts.map((c,i)=>(
          <div key={c.id} style={{ background:"#FFF1F2", borderRadius:12, padding:"14px 16px", marginBottom:10 }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
              <Badge text={`CONTACT ${i+1}`} color="#DC2626" />
              <RemBtn onClick={()=>remC(c.id)} />
            </div>
            <div style={S.grid3}>
              <Field label="Name"><Inp value={c.name} onChange={v=>updC(c.id,"name",v)} /></Field>
              <Field label="Relation"><Inp value={c.relation} onChange={v=>updC(c.id,"relation",v)} placeholder="Parent, Spouse..." /></Field>
              <Field label="Cell Phone"><Inp value={c.cell} onChange={v=>updC(c.id,"cell",v)} /></Field>
              <Field label="Home Phone"><Inp value={c.home} onChange={v=>updC(c.id,"home",v)} /></Field>
              <Field label="Email"><Inp value={c.email} onChange={v=>updC(c.id,"email",v)} /></Field>
            </div>
          </div>
        ))}
        {contacts.length===0&&<div style={{ color:"#94a3b8", fontSize:13 }}>No contacts added yet.</div>}
      </div>
      <div style={S.card}>
        <SecHead title="Destination Numbers" color="#475569" />
        <div style={S.grid2}>
          {[["localPolice","Local Police (non-emergency)"],["nearestHospital","Nearest Hospital"],["hotelLine","Hotel Emergency Line"],["embassy","US Embassy / Consulate"],["roadside","Roadside Assistance"],["poisonControl","Poison Control"]].map(([k,l])=>(
            <Field key={k} label={l}><Inp value={emergency[k]} onChange={v=>u(k,v)} /></Field>
          ))}
        </div>
      </div>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// DISNEY (enhanced — Lightning Lane tracker, must-do rides, dining)
// ══════════════════════════════════════════════════
function Disney({ disney, setDisney }) {
  const t = TABS.find(t=>t.id==="disney");
  const upd = (section,k,v) => setDisney(d=>({...d,[section]:{...d[section],[k]:v}}));
  const toggleLL = (park,ride) => {
    const key = `ll__${park}__${ride}`;
    setDisney(d=>({...d,llChecks:{...d.llChecks,[key]:!d.llChecks?.[key]}}));
  };
  const toggleRide = (park,ride) => {
    const key = `done__${park}__${ride}`;
    setDisney(d=>({...d,rideDone:{...d.rideDone,[key]:!d.rideDone?.[key]}}));
  };
  const addDining = () => setDisney(d=>({...d,diningRes:[...(d.diningRes||[]),{id:Date.now(),restaurant:"",date:"",time:"",party:"",confirmation:"",notes:""}]}));
  const updDining = (id,k,v) => setDisney(d=>({...d,diningRes:(d.diningRes||[]).map(r=>r.id===id?{...r,[k]:v}:r)}));
  const remDining = id => setDisney(d=>({...d,diningRes:(d.diningRes||[]).filter(r=>r.id!==id)}));
  const parkColors = { "Magic Kingdom":"#7C3AED","EPCOT":"#0284C7","Hollywood Studios":"#EA580C","Animal Kingdom":"#16A34A" };
  return (
    <div>
      <Banner icon={t.icon} title="Disney World Planner" subtitle="Lightning Lane tracker, must-do rides, dining reservations & more" color={t.color} />
      {/* Basics */}
      <div style={S.card}>
        <SecHead title="Disney Basics" color={t.color} />
        <div style={S.grid2}>
          {[["resort","Resort Name"],["resortConfirm","Resort Confirmation #"],["ticketType","Ticket Type / Tier"],["geniePlus","Lightning Lane Multi Pass Plan"],["specialEvents","Special Events (MNSSHP, MVMCP, etc.)"],["notes","General Notes"]].map(([k,l])=>(
            <Field key={k} label={l}><Inp value={disney?.basics?.[k]} onChange={v=>upd("basics",k,v)} /></Field>
          ))}
        </div>
      </div>
      {/* Park Days */}
      <div style={S.card}>
        <SecHead title="Park Days" color={t.color} />
        <div style={S.grid2}>
          {["Day 1","Day 2","Day 3","Day 4","Day 5","Day 6"].map(day=>(
            <Field key={day} label={`${day} — Which Park?`}>
              <Sel value={disney?.parkDays?.[day]||""} onChange={v=>upd("parkDays",day,v)}
                options={["—Select—","Magic Kingdom","EPCOT","Hollywood Studios","Animal Kingdom","Rest Day","Resort Day","Disney Springs"]} />
            </Field>
          ))}
        </div>
      </div>
      {/* Lightning Lane Tracker */}
      <div style={S.card}>
        <SecHead title="⚡ Lightning Lane Tracker" color="#F59E0B" />
        <div style={{ marginBottom:10, fontSize:13, color:"#64748b" }}>Check off rides as you secure Lightning Lane reservations. Tap to mark completed on the day!</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:14 }}>
          {Object.entries(LL_RIDES).map(([park,rides])=>(
            <div key={park} style={{ background:`${parkColors[park]}10`, borderRadius:12, padding:14, border:`1.5px solid ${parkColors[park]}30` }}>
              <div style={{ fontWeight:800, color:parkColors[park], fontSize:13, marginBottom:10 }}>{park}</div>
              {rides.map(ride=>(
                <CheckRow key={ride} label={ride}
                  checked={!!disney?.llChecks?.[`ll__${park}__${ride}`]}
                  onToggle={()=>toggleLL(park,ride)}
                  color={parkColors[park]} />
              ))}
            </div>
          ))}
        </div>
      </div>
      {/* Must-Do Rides */}
      <div style={S.card}>
        <SecHead title="✅ Must-Do Ride Tracker" color="#16A34A" />
        <div style={{ marginBottom:10, fontSize:13, color:"#64748b" }}>Check off each ride as you complete it during your visit.</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:14 }}>
          {Object.entries(LL_RIDES).map(([park,rides])=>(
            <div key={park} style={{ background:`${parkColors[park]}10`, borderRadius:12, padding:14, border:`1.5px solid ${parkColors[park]}30` }}>
              <div style={{ fontWeight:800, color:parkColors[park], fontSize:13, marginBottom:10 }}>{park}</div>
              {rides.map(ride=>(
                <CheckRow key={ride} label={ride}
                  checked={!!disney?.rideDone?.[`done__${park}__${ride}`]}
                  onToggle={()=>toggleRide(park,ride)}
                  color={parkColors[park]} />
              ))}
            </div>
          ))}
        </div>
      </div>
      {/* Dining Reservations */}
      <div style={S.card}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
          <SecHead title="🍽️ Dining Reservations" color="#D97706" />
          <Btn onClick={addDining} color="#D97706">+ Add Dining Res.</Btn>
        </div>
        {(disney?.diningRes||[]).map((r,i)=>(
          <div key={r.id} style={{ background:"#FFFBEB", borderRadius:12, padding:"14px 16px", marginBottom:10, border:"1px solid #fde68a" }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
              <Badge text={`DINING ${i+1}`} color="#D97706" />
              <RemBtn onClick={()=>remDining(r.id)} />
            </div>
            <div style={S.grid3}>
              <Field label="Restaurant"><Inp value={r.restaurant} onChange={v=>updDining(r.id,"restaurant",v)} placeholder="Be Our Guest" /></Field>
              <Field label="Date"><Inp type="date" value={r.date} onChange={v=>updDining(r.id,"date",v)} /></Field>
              <Field label="Time"><Inp type="time" value={r.time} onChange={v=>updDining(r.id,"time",v)} /></Field>
              <Field label="Party Size"><Inp type="number" value={r.party} onChange={v=>updDining(r.id,"party",v)} placeholder="4" /></Field>
              <Field label="Confirmation #"><Inp value={r.confirmation} onChange={v=>updDining(r.id,"confirmation",v)} /></Field>
            </div>
            <Field label="Notes"><Inp value={r.notes} onChange={v=>updDining(r.id,"notes",v)} placeholder="Dress code, special requests, character meal..." /></Field>
          </div>
        ))}
        {!(disney?.diningRes?.length)&&<div style={{ color:"#94a3b8", fontSize:13 }}>No dining reservations added yet.</div>}
      </div>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// CRUISE (enhanced — embarkation checklist, sea days, excursions)
// ══════════════════════════════════════════════════
const EMBARK_CHECKLIST = [
  "Passports / ID packed in carry-on","Boarding passes printed or on phone",
  "Credit card for onboard account registered","Luggage tags attached to all bags",
  "Medications in carry-on (not checked luggage)","Cruise confirmation # saved offline",
  "Travel insurance info printed","Emergency contact info saved",
  "Arrive at port 2 hrs before departure","Muster drill attended",
];
const SEA_DAY_IDEAS = [
  "Spa / Thermal Suite","Trivia / Game Shows","Pool deck / Hot tub","Rock climbing wall / Ropes course",
  "Casino","Live music / Entertainment","Wine or cocktail tasting","Cooking class",
  "Movie on the Lido Deck","Specialty dining dinner","Fitness class","Art auction",
  "Kids club drop-off","Bingo","Onboard shopping deals",
];

function Cruise({ cruise, setCruise, excursions, setExcursions }) {
  const t = TABS.find(t=>t.id==="cruise");
  const upd = (k,v) => setCruise(c=>({...c,[k]:v}));
  const toggleEmb = (item) => setCruise(c=>({...c,embarkChecks:{...c.embarkChecks,[item]:!c.embarkChecks?.[item]}}));
  const toggleSea = (item) => setCruise(c=>({...c,seaDayChecks:{...c.seaDayChecks,[item]:!c.seaDayChecks?.[item]}}));
  const addE = () => setExcursions(e=>[...e,{id:Date.now(),port:"",date:"",activity:"",operator:"",booking:"",cost:"",notes:""}]);
  const updE = (id,k,v) => setExcursions(e=>e.map(r=>r.id===id?{...r,[k]:v}:r));
  const remE = id => setExcursions(e=>e.filter(r=>r.id!==id));
  const embDone = EMBARK_CHECKLIST.filter(i=>cruise?.embarkChecks?.[i]).length;
  return (
    <div>
      <Banner icon={t.icon} title="Cruise Planner" subtitle="Cruise basics, embarkation checklist, port excursions & sea days" color={t.color} />
      {/* Cruise Basics */}
      <div style={S.card}>
        <SecHead title="Cruise Basics" color={t.color} />
        <div style={S.grid2}>
          {[["line","Cruise Line"],["ship","Ship Name"],["cabin","Cabin Number"],["booking","Booking #"],["muster","Muster Station"],["embarkPort","Embarkation Port"],["disembarkPort","Disembarkation Port"],["embarkDate","Embark Date"],["disembarkDate","Disembark Date"],["dining","Dining Seating"],["loyaltyNum","Loyalty / Club Number"],["notes","Notes"]].map(([k,l])=>(
            <Field key={k} label={l}><Inp value={cruise?.[k]} onChange={v=>upd(k,v)} type={k.includes("Date")?"date":"text"} /></Field>
          ))}
        </div>
      </div>
      {/* Embarkation Checklist */}
      <div style={S.card}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
          <SecHead title="🚢 Embarkation Day Checklist" color="#0369A1" />
          <Badge text={`${embDone}/${EMBARK_CHECKLIST.length} done`} color="#0369A1" />
        </div>
        {EMBARK_CHECKLIST.map(item=>(
          <CheckRow key={item} label={item} checked={!!cruise?.embarkChecks?.[item]} onToggle={()=>toggleEmb(item)} color="#0369A1" />
        ))}
      </div>
      {/* Port Excursions */}
      <div style={S.card}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
          <SecHead title="⚓ Port & Shore Excursions" color="#0D9488" />
          <Btn onClick={addE} color="#0D9488">+ Add Excursion</Btn>
        </div>
        {excursions.map((ex,i)=>(
          <div key={ex.id} style={{ background:"#F0FDFA", borderRadius:12, padding:"14px 16px", marginBottom:10 }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:10 }}>
              <Badge text={`EXCURSION ${i+1}`} color="#0D9488" />
              <RemBtn onClick={()=>remE(ex.id)} />
            </div>
            <div style={S.grid3}>
              <Field label="Port / Destination"><Inp value={ex.port} onChange={v=>updE(ex.id,"port",v)} placeholder="Nassau, Bahamas" /></Field>
              <Field label="Date"><Inp type="date" value={ex.date} onChange={v=>updE(ex.id,"date",v)} /></Field>
              <Field label="Activity"><Inp value={ex.activity} onChange={v=>updE(ex.id,"activity",v)} placeholder="Snorkel tour, Atlantis, etc." /></Field>
              <Field label="Operator"><Inp value={ex.operator} onChange={v=>updE(ex.id,"operator",v)} placeholder="Viator, ship excursion..." /></Field>
              <Field label="Booking #"><Inp value={ex.booking} onChange={v=>updE(ex.id,"booking",v)} /></Field>
              <Field label="Cost ($)"><Inp type="number" value={ex.cost} onChange={v=>updE(ex.id,"cost",v)} /></Field>
            </div>
            <Field label="Notes"><Inp value={ex.notes} onChange={v=>updE(ex.id,"notes",v)} /></Field>
          </div>
        ))}
        {excursions.length===0&&<div style={{ color:"#94a3b8", fontSize:13 }}>No excursions added yet.</div>}
      </div>
      {/* Sea Day Activities */}
      <div style={S.card}>
        <SecHead title="🌊 Sea Day Activity Ideas" color="#7C3AED" />
        <div style={{ marginBottom:10, fontSize:13, color:"#64748b" }}>Check off activities you want to do on sea days — great for planning ahead!</div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:4 }}>
          {SEA_DAY_IDEAS.map(item=>(
            <CheckRow key={item} label={item} checked={!!cruise?.seaDayChecks?.[item]} onToggle={()=>toggleSea(item)} color="#7C3AED" />
          ))}
        </div>
        <Field label="Sea Day Notes / Plans" style={{ marginTop:14 }}>
          <Inp value={cruise?.seaDayNotes} onChange={v=>upd("seaDayNotes",v)} placeholder="Other sea day plans, specialty dining, shows to book..." />
        </Field>
      </div>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// GATLINBURG (new tab)
// ══════════════════════════════════════════════════
const DOLLYWOOD_RIDES = ["Wild Eagle","FireChaser Express","Lightning Rod","Drop Line","Mystery Mine","Tennessee Tornado","Blazing Fury","Timber Tower","River Battle","Barnstormer"];
const SMOKY_TRAILS = [
  { name:"Alum Cave Trail", diff:"Moderate", miles:"4.4 RT" },
  { name:"Laurel Falls Trail", diff:"Easy", miles:"2.6 RT" },
  { name:"Chimney Tops Trail", diff:"Strenuous", miles:"3.9 RT" },
  { name:"Rainbow Falls Trail", diff:"Moderate", miles:"5.4 RT" },
  { name:"Andrews Bald Trail", diff:"Moderate", miles:"3.6 RT" },
  { name:"Abrams Falls Trail", diff:"Moderate", miles:"5.0 RT" },
  { name:"Grotto Falls Trail", diff:"Easy-Mod", miles:"2.6 RT" },
];

function Gatlinburg({ gatlinburg, setGatlinburg }) {
  const t = TABS.find(t=>t.id==="gatlinburg");
  const upd = (k,v) => setGatlinburg(g=>({...g,[k]:v}));
  const updCabin = (k,v) => setGatlinburg(g=>({...g,cabin:{...g.cabin,[k]:v}}));
  const toggleDW = ride => setGatlinburg(g=>({...g,dollywoodRides:{...g.dollywoodRides,[ride]:!g.dollywoodRides?.[ride]}}));
  const toggleTrail = name => setGatlinburg(g=>({...g,trailsDone:{...g.trailsDone,[name]:!g.trailsDone?.[name]}}));
  const CABIN_AMENITIES = ["Hot Tub","Pool Table","Air Hockey","Foosball","Arcade Games","Movie Theater Room","Fire Pit","Fireplace","Mountain View","Game Room","Wi-Fi","Grill / BBQ"];
  const toggleAmenity = a => setGatlinburg(g=>({...g,cabinAmenities:{...g.cabinAmenities,[a]:!g.cabinAmenities?.[a]}}));
  const addRest = () => setGatlinburg(g=>({...g,restaurants:[...(g.restaurants||[]),{id:Date.now(),name:"",type:"",address:"",notes:"",visited:false}]}));
  const updRest = (id,k,v) => setGatlinburg(g=>({...g,restaurants:(g.restaurants||[]).map(r=>r.id===id?{...r,[k]:v}:r)}));
  const remRest = id => setGatlinburg(g=>({...g,restaurants:(g.restaurants||[]).filter(r=>r.id!==id)}));
  const toggleVisited = id => setGatlinburg(g=>({...g,restaurants:(g.restaurants||[]).map(r=>r.id===id?{...r,visited:!r.visited}:r)}));
  return (
    <div>
      <Banner icon={t.icon} title="Gatlinburg & Pigeon Forge" subtitle="Cabin info, Dollywood planner, hiking tracker & restaurant list" color={t.color} />
      {/* Cabin Info */}
      <div style={S.card}>
        <SecHead title="🏕️ Cabin / Rental Info" color={t.color} />
        <div style={S.grid2}>
          {[["name","Cabin / Rental Name"],["address","Address"],["checkIn","Check-In Date"],["checkOut","Check-Out Date"],["confirmation","Confirmation #"],["phone","Contact Phone"],["nightly","Nightly Rate ($)"],["cleaningFee","Cleaning Fee ($)"]].map(([k,l])=>(
            <Field key={k} label={l}><Inp value={gatlinburg?.cabin?.[k]} onChange={v=>updCabin(k,v)} type={k.includes("check")||k.includes("Check")?"date":"text"} /></Field>
          ))}
        </div>
        <Field label="Cabin Notes / Access Code"><Inp value={gatlinburg?.cabin?.notes} onChange={v=>updCabin("notes",v)} placeholder="Access code, parking, check-in instructions..." /></Field>
        <div style={{ marginTop:14 }}>
          <div style={S.label}>Cabin Amenities</div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:6 }}>
            {CABIN_AMENITIES.map(a=>(
              <CheckRow key={a} label={a} checked={!!gatlinburg?.cabinAmenities?.[a]} onToggle={()=>toggleAmenity(a)} color={t.color} />
            ))}
          </div>
        </div>
      </div>
      {/* Dollywood */}
      <div style={S.card}>
        <SecHead title="🎡 Dollywood Planner" color="#E11D48" />
        <div style={S.grid2}>
          {[["dollywoodDate","Visit Date"],["dollywoodTickets","Ticket Type"],["dollywoodConfirm","Ticket Confirmation #"],["dollywoodBudget","Budget ($)"]].map(([k,l])=>(
            <Field key={k} label={l}><Inp value={gatlinburg?.[k]} onChange={v=>upd(k,v)} type={k.includes("Date")?"date":"text"} /></Field>
          ))}
        </div>
        <div style={{ marginTop:10 }}>
          <div style={S.label}>Must-Do Rides at Dollywood</div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:4, marginTop:6 }}>
            {DOLLYWOOD_RIDES.map(ride=>(
              <CheckRow key={ride} label={ride} checked={!!gatlinburg?.dollywoodRides?.[ride]} onToggle={()=>toggleDW(ride)} color="#E11D48" />
            ))}
          </div>
        </div>
        <Field label="Shows / Events to See" style={{ marginTop:14 }}>
          <Inp value={gatlinburg?.dollywoodShows} onChange={v=>upd("dollywoodShows",v)} placeholder="Southern Gospel Jubilee, Dollywood's Smoky Mountain Christmas..." />
        </Field>
      </div>
      {/* Hiking */}
      <div style={S.card}>
        <SecHead title="🥾 Smoky Mountain Hiking" color="#0D9488" />
        <div style={{ marginBottom:10, fontSize:13, color:"#64748b" }}>Check off trails as you complete them. All distances are round trip.</div>
        <div style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
            <thead>
              <tr style={{ background:"#f0fdfa" }}>
                {["Trail","Difficulty","Distance","Done?"].map(h=>(
                  <th key={h} style={{ padding:"8px 12px", textAlign:"left", fontWeight:700, color:"#0D9488", fontSize:11 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {SMOKY_TRAILS.map(trail=>{
                const done = !!gatlinburg?.trailsDone?.[trail.name];
                const diffColor = trail.diff==="Easy"?"#16A34A":trail.diff==="Moderate"?"#D97706":"#DC2626";
                return (
                  <tr key={trail.name} style={{ borderBottom:"1px solid #f1f5f9", background:done?"#f0fdfa":"#fff", cursor:"pointer" }} onClick={()=>toggleTrail(trail.name)}>
                    <td style={{ padding:"10px 12px", fontWeight:600, textDecoration:done?"line-through":"none", color:done?"#94a3b8":"#1e293b" }}>{trail.name}</td>
                    <td style={{ padding:"10px 12px" }}><Badge text={trail.diff} color={diffColor} /></td>
                    <td style={{ padding:"10px 12px", color:"#64748b" }}>{trail.miles}</td>
                    <td style={{ padding:"10px 12px" }}>
                      <div style={{ width:20, height:20, borderRadius:5, border:`2px solid ${done?"#0D9488":"#cbd5e1"}`, background:done?"#0D9488":"#fff", display:"flex", alignItems:"center", justifyContent:"center" }}>
                        {done&&<span style={{ color:"#fff", fontSize:12 }}>✓</span>}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Field label="Custom Hike Notes" style={{ marginTop:14 }}>
          <Inp value={gatlinburg?.hikeNotes} onChange={v=>upd("hikeNotes",v)} placeholder="Other trails, conditions, gear needed..." />
        </Field>
      </div>
      {/* Restaurants */}
      <div style={S.card}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
          <SecHead title="🍽️ Restaurant List" color="#D97706" />
          <Btn onClick={addRest} color="#D97706">+ Add Restaurant</Btn>
        </div>
        {(gatlinburg?.restaurants||[]).map((r,i)=>(
          <div key={r.id} style={{ background:r.visited?"#f0fdf4":"#fffbeb", borderRadius:12, padding:"14px 16px", marginBottom:10, border:`1px solid ${r.visited?"#a7f3d0":"#fde68a"}` }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
              <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                <Badge text={`REST ${i+1}`} color="#D97706" />
                {r.visited&&<Badge text="✓ Visited" color="#16A34A" />}
              </div>
              <div style={{ display:"flex", gap:6 }}>
                <Btn onClick={()=>toggleVisited(r.id)} color={r.visited?"#16A34A":"#64748b"} style={{ padding:"5px 12px", fontSize:12 }}>
                  {r.visited?"✓ Visited":"Mark Visited"}
                </Btn>
                <RemBtn onClick={()=>remRest(r.id)} />
              </div>
            </div>
            <div style={S.grid3}>
              <Field label="Restaurant Name"><Inp value={r.name} onChange={v=>updRest(r.id,"name",v)} placeholder="Ole Smoky Moonshine..." /></Field>
              <Field label="Type"><Sel value={r.type} onChange={v=>updRest(r.id,"type",v)} options={["—Type—","Breakfast","BBQ","Seafood","Steakhouse","Southern","Pizza","Burgers","Dessert","Bar/Grill","Fine Dining","Other"]} /></Field>
              <Field label="Address"><Inp value={r.address} onChange={v=>updRest(r.id,"address",v)} placeholder="Gatlinburg, TN" /></Field>
            </div>
            <Field label="Notes"><Inp value={r.notes} onChange={v=>updRest(r.id,"notes",v)} placeholder="Must try dishes, reservation needed, parking tips..." /></Field>
          </div>
        ))}
        {!(gatlinburg?.restaurants?.length)&&<div style={{ color:"#94a3b8", fontSize:13 }}>No restaurants added yet.</div>}
      </div>
      {/* Attractions */}
      <div style={S.card}>
        <SecHead title="🎯 Other Attractions & Notes" color="#7C3AED" />
        <div style={S.grid2}>
          {[["attractions","Must-See Attractions"],["shopping","Shopping Spots"],["shows","Shows / Entertainment"],["misc","Other Notes / Ideas"]].map(([k,l])=>(
            <Field key={k} label={l}><Inp value={gatlinburg?.[k]} onChange={v=>upd(k,v)} placeholder={`${l}...`} /></Field>
          ))}
        </div>
      </div>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// RESERVATIONS
// ══════════════════════════════════════════════════
function Reservations({ reservations, setReservations }) {
  const t = TABS.find(t=>t.id==="reservations");
  const cats = ["🍽️ Dining","🎭 Entertainment","🚗 Car Rental","💆 Spa/Wellness","🗺️ Tour/Excursion","🅿️ Parking","👶 Childcare","📎 Other"];
  const statusColors = { Pending:"#D97706", Confirmed:"#16A34A", Waitlisted:"#7C3AED", Cancelled:"#E11D48" };
  const add = () => setReservations(it=>[...it,{ id:Date.now(), category:"🍽️ Dining", name:"", date:"", time:"", partySize:"", confirmation:"", phone:"", cost:"", notes:"", status:"Pending" }]);
  const upd = (id,k,v) => setReservations(it=>it.map(r=>r.id===id?{...r,[k]:v}:r));
  const rem = id => setReservations(it=>it.filter(r=>r.id!==id));
  const totalCost = reservations.reduce((s,r)=>s+(parseFloat(r.cost)||0),0);
  return (
    <div>
      <Banner icon={t.icon} title="Reservations Tracker" subtitle="All dining, entertainment and activity bookings in one place" color={t.color} />
      {reservations.length>0&&(
        <div style={{...S.card,background:"#ECFDF5",border:"1px solid #a7f3d0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{ fontWeight:700, color:t.color }}>{reservations.length} reservations</span>
          <span style={{ fontWeight:800, color:t.color }}>Total Reserved: ${totalCost.toFixed(2)}</span>
        </div>
      )}
      {reservations.map((res,i)=>(
        <div key={res.id} style={S.card}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
            <div style={{ display:"flex", gap:10, alignItems:"center" }}>
              <Badge text={`RES ${i+1}`} color={t.color} />
              <Sel value={res.category} onChange={v=>upd(res.id,"category",v)} options={cats} style={{ width:190 }} />
            </div>
            <div style={{ display:"flex", gap:10, alignItems:"center" }}>
              <Sel value={res.status} onChange={v=>upd(res.id,"status",v)} options={["Pending","Confirmed","Waitlisted","Cancelled"]} style={{ width:130, color:statusColors[res.status], fontWeight:700 }} />
              <RemBtn onClick={()=>rem(res.id)} />
            </div>
          </div>
          <div style={S.grid3}>
            <Field label="Venue / Restaurant"><Inp value={res.name} onChange={v=>upd(res.id,"name",v)} /></Field>
            <Field label="Date"><Inp type="date" value={res.date} onChange={v=>upd(res.id,"date",v)} /></Field>
            <Field label="Time"><Inp type="time" value={res.time} onChange={v=>upd(res.id,"time",v)} /></Field>
            <Field label="Party Size"><Inp type="number" value={res.partySize} onChange={v=>upd(res.id,"partySize",v)} /></Field>
            <Field label="Confirmation #"><Inp value={res.confirmation} onChange={v=>upd(res.id,"confirmation",v)} /></Field>
            <Field label="Total Cost ($)"><Inp type="number" value={res.cost} onChange={v=>upd(res.id,"cost",v)} /></Field>
          </div>
          <Field label="Notes"><Inp value={res.notes} onChange={v=>upd(res.id,"notes",v)} placeholder="Dress code, special requests, parking..." /></Field>
        </div>
      ))}
      {reservations.length===0&&<div style={{ textAlign:"center", padding:"40px 20px", color:"#94a3b8" }}>No reservations yet.</div>}
      <Btn onClick={add} color={t.color}>+ Add Reservation</Btn>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// DASHBOARD
// ══════════════════════════════════════════════════
function Dashboard({ trip, flights, lodging, budget, itinerary, reservations, autoAmounts }) {
  const t = TABS.find(t=>t.id==="dashboard");
  const totalBudgeted = BUDGET_CATS.reduce((s,c)=>s+(parseFloat(budget[c]?.planned)||0),0);
  const totalSpent    = BUDGET_CATS.reduce((s,c)=>s+(parseFloat(budget[c]?.actual)||0),0);
  const days = trip.startDate&&trip.endDate ? Math.ceil((new Date(trip.endDate)-new Date(trip.startDate))/86400000)+1 : null;
  const confirmed = reservations.filter(r=>r.status==="Confirmed").length;
  return (
    <div>
      <div style={{ background:"linear-gradient(135deg,#1e3a5f 0%,#14532d 100%)", borderRadius:20, padding:"24px 32px", marginBottom:20, boxShadow:"0 8px 32px rgba(30,58,95,0.3)", display:"flex", alignItems:"center", gap:20, flexWrap:"wrap" }}>
        <img src="/logo.png" alt="Thoroughbred Vacations" style={{ height:72, width:72, borderRadius:12, objectFit:"cover", flexShrink:0 }} />
        <div style={{ flex:1 }}>
          <div style={{ color:"#86efac", fontSize:11, fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:4 }}>Thoroughbred Vacations™ — Family Travel Command Center</div>
          <div style={{ color:"#fff", fontWeight:800, fontSize:28, marginBottom:4 }}>{trip.name||"My Family Trip"}</div>
          <div style={{ color:"rgba(255,255,255,0.8)", fontSize:14, display:"flex", flexWrap:"wrap", gap:16 }}>
            {trip.destination&&<span>📍 {trip.destination}</span>}
            {trip.startDate&&<span>📅 {trip.startDate} → {trip.endDate}</span>}
            {days&&<span>🌙 {days} days</span>}
            {trip.travelers&&<span>👨‍👩‍👧‍👦 {trip.travelers} travelers</span>}
          </div>
        </div>
        <button onClick={window.print} style={{ background:"rgba(255,255,255,0.18)", color:"#fff", border:"1px solid rgba(255,255,255,0.35)", borderRadius:8, padding:"8px 18px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
          🖨️ Print Summary
        </button>
      </div>
      {trip.startDate && (() => {
        const msLeft  = new Date(trip.startDate+"T00:00:00") - new Date();
        const daysLeft = Math.ceil(msLeft/86400000);
        if (daysLeft>0) return (
          <div style={{...S.card,background:"linear-gradient(135deg,#7C3AED,#2563EB)",marginBottom:20,textAlign:"center",padding:"16px 24px"}}>
            <div style={{ color:"rgba(255,255,255,0.75)", fontSize:12, fontWeight:700, letterSpacing:"0.08em", textTransform:"uppercase" }}>Countdown to your trip</div>
            <div style={{ color:"#fff", fontSize:48, fontWeight:900, lineHeight:1.1 }}>{daysLeft}</div>
            <div style={{ color:"rgba(255,255,255,0.85)", fontSize:16, fontWeight:700 }}>days to go! 🎉</div>
          </div>
        );
        if (daysLeft<=0&&daysLeft>-30) return (
          <div style={{...S.card,background:"linear-gradient(135deg,#16A34A,#0D9488)",marginBottom:20,textAlign:"center",padding:"16px 24px"}}>
            <div style={{ color:"#fff", fontSize:24, fontWeight:900 }}>✈️ You're on your trip!</div>
            <div style={{ color:"rgba(255,255,255,0.85)", fontSize:14, marginTop:4 }}>Have an amazing adventure! 🌟</div>
          </div>
        );
        return null;
      })()}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:12, marginBottom:20 }}>
        {[["✈️ Flights",`$${autoAmounts.flights.toFixed(2)}`,"#0284C7"],["🏨 Lodging",`$${autoAmounts.lodging.toFixed(2)}`,"#16A34A"],["💰 Budgeted",`$${totalBudgeted.toFixed(2)}`,"#D97706"],["💸 Spent",`$${totalSpent.toFixed(2)}`,"#DC2626"]].map(([label,val,color])=>(
          <div key={label} style={{...S.card,marginBottom:0,textAlign:"center"}}>
            <div style={{ fontSize:11, fontWeight:700, color:"#64748b", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:6 }}>{label}</div>
            <div style={{ fontSize:22, fontWeight:900, color }}>{val}</div>
          </div>
        ))}
      </div>
      {totalBudgeted>0&&(
        <div style={{...S.card,marginBottom:20}}>
          <div style={{ fontWeight:700, marginBottom:8, fontSize:13, color:"#64748b" }}>BUDGET OVERVIEW</div>
          <div style={{ background:"#e2e8f0", borderRadius:99, height:16, overflow:"hidden", marginBottom:8 }}>
            <div style={{ width:`${Math.min(100,(totalSpent/totalBudgeted)*100)}%`, background:totalSpent>totalBudgeted?"#DC2626":"#2563EB", height:"100%", borderRadius:99, transition:"width 0.4s" }} />
          </div>
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:13, color:"#64748b" }}>
            <span>${totalSpent.toFixed(2)} spent</span>
            <span style={{ fontWeight:700, color:totalBudgeted-totalSpent>=0?"#16A34A":"#DC2626" }}>
              {totalBudgeted-totalSpent>=0?`$${(totalBudgeted-totalSpent).toFixed(2)} remaining`:`$${(totalSpent-totalBudgeted).toFixed(2)} over budget`}
            </span>
            <span>${totalBudgeted.toFixed(2)} budgeted</span>
          </div>
        </div>
      )}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
        <div style={S.card}>
          <div style={{ fontWeight:800, color:"#0284C7", marginBottom:12 }}>✈️ Flights ({flights.length})</div>
          {flights.length===0?<div style={{ color:"#94a3b8", fontSize:13 }}>No flights added.</div>
            :flights.map((f,i)=>(
              <div key={f.id} style={{ padding:"7px 0", borderBottom:"1px solid #f1f5f9", fontSize:13 }}>
                <span style={{ fontWeight:700 }}>{f.route||`Leg ${i+1}`}</span>
                {f.airline&&<span style={{ color:"#64748b" }}> — {f.airline} {f.flightNo}</span>}
                <span style={{ color:"#0284C7", fontWeight:700 }}> — ${((parseFloat(f.cost)||0)+bagCalc(f)).toFixed(2)}</span>
              </div>
            ))}
        </div>
        <div style={S.card}>
          <div style={{ fontWeight:800, color:"#16A34A", marginBottom:12 }}>🏨 Lodging ({lodging.length})</div>
          {lodging.length===0?<div style={{ color:"#94a3b8", fontSize:13 }}>No lodging added.</div>
            :lodging.map((h,i)=>{
              const n=nightCalc(h);
              return (
                <div key={h.id} style={{ padding:"7px 0", borderBottom:"1px solid #f1f5f9", fontSize:13 }}>
                  <span style={{ fontWeight:700 }}>{h.name||`Stay ${i+1}`}</span>
                  {n>0&&<span style={{ color:"#64748b" }}> — {n} nights</span>}
                  <span style={{ color:"#16A34A", fontWeight:700 }}> — ${(n*(parseFloat(h.nightly)||0)).toFixed(2)}</span>
                </div>
              );
            })}
        </div>
        <div style={S.card}>
          <div style={{ fontWeight:800, color:"#7C3AED", marginBottom:12 }}>📅 Itinerary ({itinerary.length} activities)</div>
          {itinerary.length===0?<div style={{ color:"#94a3b8", fontSize:13 }}>No activities planned.</div>
            :[...itinerary].sort((a,b)=>a.date.localeCompare(b.date)).slice(0,6).map(item=>(
              <div key={item.id} style={{ padding:"6px 0", borderBottom:"1px solid #f1f5f9", fontSize:13, display:"flex", justifyContent:"space-between" }}>
                <span style={{ fontWeight:600 }}>{item.activity}</span>
                <span style={{ color:"#64748b" }}>{item.date}</span>
              </div>
            ))}
          {itinerary.length>6&&<div style={{ fontSize:12, color:"#94a3b8", marginTop:4 }}>+{itinerary.length-6} more activities</div>}
        </div>
        <div style={S.card}>
          <div style={{ fontWeight:800, color:"#059669", marginBottom:12 }}>📋 Reservations ({reservations.length})</div>
          {reservations.length===0?<div style={{ color:"#94a3b8", fontSize:13 }}>No reservations added.</div>
            :reservations.slice(0,6).map(r=>(
              <div key={r.id} style={{ padding:"6px 0", borderBottom:"1px solid #f1f5f9", fontSize:13, display:"flex", justifyContent:"space-between" }}>
                <span style={{ fontWeight:600 }}>{r.name||r.category}</span>
                <Badge text={r.status} color={{ Pending:"#D97706", Confirmed:"#16A34A", Waitlisted:"#7C3AED", Cancelled:"#E11D48" }[r.status]} />
              </div>
            ))}
          {reservations.length>0&&<div style={{ marginTop:10, fontSize:12, color:"#059669", fontWeight:700 }}>{confirmed} confirmed of {reservations.length} total</div>}
        </div>
      </div>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// TRAVEL TOOLS (weather + currency + affiliate links)
// ══════════════════════════════════════════════════
const CURRENCIES = ["USD","EUR","GBP","CAD","AUD","MXN","JPY","BRL","CHF","CZK","DKK","HKD","HUF","INR","NOK","NZD","PLN","SEK","SGD","ZAR"];
const WX_CODES = { 0:"☀️ Clear",1:"🌤 Mostly Clear",2:"⛅ Partly Cloudy",3:"☁️ Overcast",45:"🌫 Foggy",48:"🌫 Icy Fog",51:"🌦 Light Drizzle",53:"🌦 Drizzle",61:"🌧 Light Rain",63:"🌧 Rain",71:"🌨 Light Snow",73:"🌨 Snow",80:"🌦 Showers",95:"⛈ Thunderstorm" };
function Tools({ trip }) {
  const t = TABS.find(t=>t.id==="tools");
  const [weather,setWeather] = useState(null);
  const [wxLoading,setWxLoading] = useState(false);
  const [wxError,setWxError] = useState("");
  const [amount,setAmount] = useState("100");
  const [fromCur,setFromCur] = useState("USD");
  const [toCur,setToCur] = useState("EUR");
  const [rates,setRates] = useState(null);
  const [converted,setConverted] = useState("");
  const [fxLoading,setFxLoading] = useState(false);
  const [fxError,setFxError] = useState("");
  const fetchWeather = async () => {
    if(!trip.destination) { setWxError("Set your destination in the Start Here tab first."); return; }
    setWxLoading(true); setWxError(""); setWeather(null);
    try {
      const geo = await fetch(`https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(trip.destination)}&count=1`).then(r=>r.json());
      if(!geo.results?.length) throw new Error("Location not found — try a city name like 'Orlando, FL'");
      const { latitude:lat, longitude:lon, name, country_code } = geo.results[0];
      const start = trip.startDate||new Date().toISOString().slice(0,10);
      const end   = trip.endDate  ||new Date(Date.now()+7*86400000).toISOString().slice(0,10);
      const wx = await fetch(`https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&daily=temperature_2m_max,temperature_2m_min,weathercode,precipitation_sum,windspeed_10m_max&temperature_unit=fahrenheit&wind_speed_unit=mph&precipitation_unit=mm&timezone=auto&start_date=${start}&end_date=${end}`).then(r=>r.json());
      setWeather({ ...wx, locationName:`${name}, ${country_code.toUpperCase()}` });
    } catch(e) { setWxError(e.message||"Could not fetch weather."); }
    setWxLoading(false);
  };
  const fetchRates = async () => {
    setFxLoading(true); setFxError(""); setRates(null); setConverted("");
    try {
      const data = await fetch(`https://api.frankfurter.app/latest?from=${fromCur}`).then(r=>r.json());
      setRates(data);
      if(data.rates[toCur]) setConverted((parseFloat(amount||1)*data.rates[toCur]).toFixed(2));
    } catch { setFxError("Could not load rates. Check your connection."); }
    setFxLoading(false);
  };
  const AFFILIATE_LINKS = [
    { icon:"🌍", name:"Viator — Activities & Experiences", desc:"Book tours, excursions & experiences worldwide. Great for Disney day trips, cruise port activities & Gatlinburg adventures.", url:"https://www.viator.com", badge:"8% Commission" },
    { icon:"🏨", name:"Booking.com — Hotels & Rentals", desc:"Hotels, vacation rentals, cabins and resorts. Often finds better rates than the hotel's own website.", url:"https://www.booking.com", badge:"4-6% Commission" },
    { icon:"🎢", name:"Get Away Today — Disney Packages", desc:"Best prices on Disney World vacation packages. Often beats Disney's own pricing, especially for hotel + ticket bundles.", url:"https://getawaytoday.com", badge:"Disney Specialist" },
    { icon:"🚢", name:"Cruises Only — All Cruise Lines", desc:"Compare Carnival, Royal Caribbean, Norwegian, Disney Cruise and more. Great group rates and last-minute deals.", url:"https://www.cruisesonly.com", badge:"$50-150/Booking" },
    { icon:"🛒", name:"Amazon — Travel Essentials", desc:"Travel gear, packing cubes, luggage, kids' travel toys, car seat travel bags and everything on your packing list.", url:"https://www.amazon.com/travel-essentials", badge:"3-4% Commission" },
    { icon:"🏕️", name:"VRBO — Vacation Rentals", desc:"Best place to find cabins in Gatlinburg/Pigeon Forge. Filter by hot tub, mountain view, pool table and more.", url:"https://www.vrbo.com", badge:"Cabin Specialist" },
  ];
  return (
    <div>
      <Banner icon={t.icon} title="Travel Tools" subtitle="Weather forecast, currency converter & curated travel deals" color={t.color} />
      {/* Affiliate / Partner Links */}
      <div style={S.card}>
        <SecHead title="🤝 Travel Deals & Partners" color="#7C3AED" />
        <div style={{ marginBottom:14, fontSize:13, color:"#64748b" }}>We personally vet and use these partners. Booking through these links helps support Thoroughbred Vacations — at no extra cost to you.</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))", gap:14 }}>
          {AFFILIATE_LINKS.map(link=>(
            <a key={link.name} href={link.url} target="_blank" rel="noreferrer"
              style={{ display:"block", background:"#f8fafc", borderRadius:12, padding:"16px 18px", border:"1.5px solid #e2e8f0", textDecoration:"none", transition:"all 0.2s", cursor:"pointer" }}
              onMouseEnter={e=>{ e.currentTarget.style.borderColor="#7C3AED"; e.currentTarget.style.boxShadow="0 4px 16px rgba(124,58,237,0.1)"; }}
              onMouseLeave={e=>{ e.currentTarget.style.borderColor="#e2e8f0"; e.currentTarget.style.boxShadow="none"; }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                <div style={{ fontSize:22 }}>{link.icon}</div>
                <span style={{ background:"#7C3AED18", color:"#7C3AED", border:"1px solid #7C3AED33", borderRadius:99, padding:"2px 9px", fontSize:10, fontWeight:700 }}>{link.badge}</span>
              </div>
              <div style={{ fontWeight:800, color:"#1e293b", fontSize:14, marginBottom:6 }}>{link.name}</div>
              <div style={{ color:"#64748b", fontSize:12, lineHeight:1.6 }}>{link.desc}</div>
            </a>
          ))}
        </div>
      </div>
      {/* Weather */}
      <div style={S.card}>
        <SecHead title="🌤️ Destination Weather Forecast" color={t.color} />
        <div style={{ fontSize:13, color:"#64748b", marginBottom:14 }}>
          Destination: <strong style={{ color:"#1e293b" }}>{trip.destination||"Not set — go to Start Here tab"}</strong> &nbsp;|&nbsp;
          Dates: <strong style={{ color:"#1e293b" }}>{trip.startDate&&trip.endDate?`${trip.startDate} to ${trip.endDate}`:"Not set — go to Start Here tab"}</strong>
        </div>
        <Btn onClick={fetchWeather} color={t.color}>{wxLoading?"⏳ Loading...":"🌤️ Get Forecast"}</Btn>
        {wxError&&<div style={{ color:"#DC2626", fontSize:13, marginTop:10 }}>⚠️ {wxError}</div>}
        {weather&&(
          <div style={{ marginTop:16 }}>
            <div style={{ fontWeight:700, color:t.color, marginBottom:12 }}>{weather.locationName} — {weather.daily.time.length}-Day Forecast</div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(110px,1fr))", gap:10 }}>
              {weather.daily.time.map((date,i)=>{
                const code=weather.daily.weathercode[i];
                const [icon,desc]=(WX_CODES[code]||"🌡️ Unknown").split(" ");
                const hi=Math.round(weather.daily.temperature_2m_max[i]);
                const lo=Math.round(weather.daily.temperature_2m_min[i]);
                const rain=weather.daily.precipitation_sum[i];
                return (
                  <div key={date} style={{ background:"#f0f9ff", borderRadius:12, padding:"12px 8px", textAlign:"center", border:"1.5px solid #bae6fd" }}>
                    <div style={{ fontSize:10, fontWeight:700, color:"#64748b", marginBottom:6 }}>
                      {new Date(date+"T12:00:00").toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"})}
                    </div>
                    <div style={{ fontSize:26, marginBottom:4 }}>{icon}</div>
                    <div style={{ fontSize:10, color:"#475569", marginBottom:6 }}>{desc}</div>
                    <div style={{ fontWeight:900, color:t.color, fontSize:14 }}>{hi}°F</div>
                    <div style={{ fontSize:11, color:"#64748b" }}>Lo {lo}°F</div>
                    {rain>0&&<div style={{ fontSize:10, color:"#0284C7", marginTop:4 }}>{rain.toFixed(1)}mm</div>}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {!weather&&!wxLoading&&!wxError&&(
          <div style={{ textAlign:"center", padding:"20px 0", color:"#94a3b8", fontSize:13 }}>
            Set your destination and dates in Start Here, then click Get Forecast above.
          </div>
        )}
      </div>
      {/* Currency */}
      <div style={S.card}>
        <SecHead title="💱 Currency Converter" color="#059669" />
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:"0 16px", marginBottom:14 }}>
          <Field label="Amount"><Inp type="number" value={amount} onChange={v=>setAmount(v)} placeholder="100" /></Field>
          <Field label="From Currency"><Sel value={fromCur} onChange={v=>{ setFromCur(v); setRates(null); }} options={CURRENCIES} /></Field>
          <Field label="To Currency"><Sel value={toCur} onChange={v=>setToCur(v)} options={CURRENCIES.filter(c=>c!==fromCur)} /></Field>
          <Field label=" "><Btn onClick={fetchRates} color="#059669">{fxLoading?"⏳ Loading...":"🔄 Get Rates"}</Btn></Field>
        </div>
        {fxError&&<div style={{ color:"#DC2626", fontSize:13, marginBottom:10 }}>⚠️ {fxError}</div>}
        {converted&&rates&&(
          <div style={{ background:"#f0fdf4", borderRadius:14, padding:"20px 24px", border:"2px solid #a7f3d0", textAlign:"center", marginBottom:16 }}>
            <div style={{ fontSize:14, color:"#64748b", marginBottom:6 }}>{amount} {fromCur} =</div>
            <div style={{ fontSize:36, fontWeight:900, color:"#059669" }}>{converted} {toCur}</div>
            <div style={{ fontSize:11, color:"#94a3b8", marginTop:6 }}>Live rate via Frankfurter API — Rates updated: {rates.date}</div>
          </div>
        )}
        {rates&&(
          <div>
            <div style={{ fontWeight:700, fontSize:12, color:"#64748b", marginBottom:10, textTransform:"uppercase", letterSpacing:"0.06em" }}>Quick Reference — {amount||1} {fromCur} converted</div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(100px,1fr))", gap:8 }}>
              {CURRENCIES.filter(c=>c!==fromCur&&rates.rates[c]).map(c=>(
                <div key={c} onClick={()=>setToCur(c)} style={{ background:c===toCur?"#f0fdf4":"#f8fafc", borderRadius:10, padding:"10px 12px", border:`1.5px solid ${c===toCur?"#16A34A":"#e2e8f0"}`, cursor:"pointer" }}>
                  <div style={{ fontSize:10, fontWeight:700, color:"#64748b" }}>{c}</div>
                  <div style={{ fontSize:15, fontWeight:800, color:c===toCur?"#059669":"#1e293b" }}>{(parseFloat(amount||1)*rates.rates[c]).toFixed(2)}</div>
                </div>
              ))}
            </div>
          </div>
        )}
        {!rates&&!fxLoading&&<div style={{ textAlign:"center", padding:"16px 0", color:"#94a3b8", fontSize:13 }}>Click Get Rates to load live exchange rates.</div>}
      </div>
      <Copyright />
    </div>
  );
}

// ══════════════════════════════════════════════════
// STORAGE
// ══════════════════════════════════════════════════
const STORAGE_KEY = "ftcc_trip_data_v12";
function loadFromStorage() { try { const r=localStorage.getItem(STORAGE_KEY); return r?JSON.parse(r):null; } catch { return null; } }
function saveToStorage(data) { try { localStorage.setItem(STORAGE_KEY,JSON.stringify(data)); } catch {} }
function exportTrip(data,tripName) {
  const blob=new Blob([JSON.stringify(data,null,2)],{type:"application/json"});
  const url=URL.createObjectURL(blob);
  const a=document.createElement("a"); a.href=url; a.download=`${(tripName||"my-trip").replace(/\s+/g,"-").toLowerCase()}.ftcc.json`; a.click();
  URL.revokeObjectURL(url);
}
function importTrip(file,onLoad) { const reader=new FileReader(); reader.onload=e=>{ try{onLoad(JSON.parse(e.target.result));}catch{alert("Could not read file.");}}; reader.readAsText(file); }
const EMPTY = {
  trip:{ name:"", destination:"", startDate:"", endDate:"", travelers:"", tripType:"", budgetGoal:"", notes:"" },
  flights:[], lodging:[], itinerary:[], budget:{}, packing:{}, emergency:{}, contacts:[],
  disney:{}, cruise:{}, excursions:[], gatlinburg:{}, reservations:[]
};

// ══════════════════════════════════════════════════
// ROOT APP
// ══════════════════════════════════════════════════
export default function App() {
  const saved = loadFromStorage();
  const [activeTab,    setActiveTab]    = useState("start");
  const [trip,         setTrip]         = useState(saved?.trip         || EMPTY.trip);
  const [flights,      setFlights]      = useState(saved?.flights      || []);
  const [lodging,      setLodging]      = useState(saved?.lodging      || []);
  const [itinerary,    setItinerary]    = useState(saved?.itinerary    || []);
  const [budget,       setBudget]       = useState(saved?.budget       || {});
  const [packing,      setPacking]      = useState(saved?.packing      || {});
  const [emergency,    setEmergency]    = useState(saved?.emergency    || {});
  const [contacts,     setContacts]     = useState(saved?.contacts     || []);
  const [disney,       setDisney]       = useState(saved?.disney       || {});
  const [cruise,       setCruise]       = useState(saved?.cruise       || {});
  const [excursions,   setExcursions]   = useState(saved?.excursions   || []);
  const [gatlinburg,   setGatlinburg]   = useState(saved?.gatlinburg   || {});
  const [reservations, setReservations] = useState(saved?.reservations || []);
  const [saveFlash,    setSaveFlash]    = useState(false);
  const [installPrompt,setInstallPrompt]= useState(null);
  const [showInstall,  setShowInstall]  = useState(false);

  // Inject print styles once
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `@media print { .tv-navbar, .tv-tabbar { display:none !important; } body { background:#fff !important; } }`;
    document.head.appendChild(style);
  }, []);

  useEffect(() => {
    const handler=(e)=>{ e.preventDefault(); setInstallPrompt(e); setShowInstall(true); };
    window.addEventListener("beforeinstallprompt",handler);
    return ()=>window.removeEventListener("beforeinstallprompt",handler);
  }, []);

  const getAll = () => ({ trip,flights,lodging,itinerary,budget,packing,emergency,contacts,disney,cruise,excursions,gatlinburg,reservations });
  const s = (setter,key) => (v) => { setter(v); setTimeout(()=>saveToStorage({...getAll(),[key]:typeof v==="function"?v(eval(key)):v}),0); };
  const setTripS         = (v) => { setTrip(v);         setTimeout(()=>saveToStorage({...getAll(),trip:typeof v==="function"?v(trip):v}),0); };
  const setFlightsS      = (v) => { setFlights(v);      setTimeout(()=>saveToStorage({...getAll(),flights:typeof v==="function"?v(flights):v}),0); };
  const setLodgingS      = (v) => { setLodging(v);      setTimeout(()=>saveToStorage({...getAll(),lodging:typeof v==="function"?v(lodging):v}),0); };
  const setItineraryS    = (v) => { setItinerary(v);    setTimeout(()=>saveToStorage({...getAll(),itinerary:typeof v==="function"?v(itinerary):v}),0); };
  const setBudgetS       = (v) => { setBudget(v);       setTimeout(()=>saveToStorage({...getAll(),budget:typeof v==="function"?v(budget):v}),0); };
  const setPackingS      = (v) => { setPacking(v);      setTimeout(()=>saveToStorage({...getAll(),packing:typeof v==="function"?v(packing):v}),0); };
  const setEmergencyS    = (v) => { setEmergency(v);    setTimeout(()=>saveToStorage({...getAll(),emergency:typeof v==="function"?v(emergency):v}),0); };
  const setContactsS     = (v) => { setContacts(v);     setTimeout(()=>saveToStorage({...getAll(),contacts:typeof v==="function"?v(contacts):v}),0); };
  const setDisneyS       = (v) => { setDisney(v);       setTimeout(()=>saveToStorage({...getAll(),disney:typeof v==="function"?v(disney):v}),0); };
  const setCruiseS       = (v) => { setCruise(v);       setTimeout(()=>saveToStorage({...getAll(),cruise:typeof v==="function"?v(cruise):v}),0); };
  const setExcursionsS   = (v) => { setExcursions(v);   setTimeout(()=>saveToStorage({...getAll(),excursions:typeof v==="function"?v(excursions):v}),0); };
  const setGatlinburgS   = (v) => { setGatlinburg(v);   setTimeout(()=>saveToStorage({...getAll(),gatlinburg:typeof v==="function"?v(gatlinburg):v}),0); };
  const setReservationsS = (v) => { setReservations(v); setTimeout(()=>saveToStorage({...getAll(),reservations:typeof v==="function"?v(reservations):v}),0); };

  const handleExport = () => { exportTrip(getAll(),trip.name); setSaveFlash(true); setTimeout(()=>setSaveFlash(false),2500); };
  const handleImport = (e) => {
    const file=e.target.files[0]; if(!file)return;
    importTrip(file,(data)=>{
      setTrip(data.trip||EMPTY.trip); setFlights(data.flights||[]); setLodging(data.lodging||[]);
      setItinerary(data.itinerary||[]); setBudget(data.budget||{}); setPacking(data.packing||{});
      setEmergency(data.emergency||{}); setContacts(data.contacts||[]); setDisney(data.disney||{});
      setCruise(data.cruise||{}); setExcursions(data.excursions||[]); setGatlinburg(data.gatlinburg||{});
      setReservations(data.reservations||[]); saveToStorage(data); setActiveTab("start");
    });
    e.target.value="";
  };
  const handleNewTrip = () => {
    if(!window.confirm("Start a new trip? Current data will be cleared. Save first if needed!"))return;
    setTrip(EMPTY.trip); setFlights([]); setLodging([]); setItinerary([]); setBudget({});
    setPacking({}); setEmergency({}); setContacts([]); setDisney({}); setCruise({});
    setExcursions([]); setGatlinburg({}); setReservations([]); saveToStorage(EMPTY); setActiveTab("start");
  };
  const handleInstall = () => { if(installPrompt){installPrompt.prompt(); installPrompt.userChoice.then(()=>{setInstallPrompt(null);setShowInstall(false);}); }};

  const autoAmounts = (() => {
    const flightTotal  = flights.reduce((s,f)=>s+(parseFloat(f.cost)||0)+bagCalc(f),0);
    const lodgingTotal = lodging.reduce((s,h)=>s+nightCalc(h)*(parseFloat(h.nightly)||0),0);
    const actTotal     = itinerary.reduce((s,i)=>s+(parseFloat(i.cost)||0),0);
    return {
      flights:flightTotal, lodging:lodgingTotal, activities:actTotal,
      byCat:{
        "✈️ Flights":flightTotal,"🏨 Lodging":lodgingTotal,"🍽️ Dining":0,
        "🎡 Activities & Parks":actTotal,"🚗 Transportation":0,"🛍️ Shopping":0,
        "💊 Health & Pharmacy":0,"🎁 Souvenirs & Misc":0,"📎 Other":0,
      }
    };
  })();

  const tab = TABS.find(t=>t.id===activeTab);

  const render = () => {
    switch(activeTab) {
      case "start":        return <StartHere trip={trip} setTrip={setTripS} />;
      case "flights":      return <Flights flights={flights} setFlights={setFlightsS} />;
      case "lodging":      return <Lodging lodging={lodging} setLodging={setLodgingS} />;
      case "itinerary":    return <Itinerary itinerary={itinerary} setItinerary={setItineraryS} />;
      case "budget":       return <Budget budget={budget} setBudget={setBudgetS} autoAmounts={autoAmounts} />;
      case "packing":      return <Packing packing={packing} setPacking={setPackingS} />;
      case "emergency":    return <Emergency emergency={emergency} setEmergency={setEmergencyS} contacts={contacts} setContacts={setContactsS} />;
      case "disney":       return <Disney disney={disney} setDisney={setDisneyS} />;
      case "cruise":       return <Cruise cruise={cruise} setCruise={setCruiseS} excursions={excursions} setExcursions={setExcursionsS} />;
      case "gatlinburg":   return <Gatlinburg gatlinburg={gatlinburg} setGatlinburg={setGatlinburgS} />;
      case "reservations": return <Reservations reservations={reservations} setReservations={setReservationsS} />;
      case "dashboard":    return <Dashboard trip={trip} flights={flights} lodging={lodging} budget={budget} itinerary={itinerary} reservations={reservations} autoAmounts={autoAmounts} />;
      case "tools":        return <Tools trip={trip} />;
      default:             return null;
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"#f1f5f9", fontFamily:"system-ui,sans-serif" }}>
      {/* HEADER */}
      <div className="tv-navbar" style={{ background:"linear-gradient(135deg,#1e3a5f 0%,#14532d 100%)", padding:"10px 20px", display:"flex", alignItems:"center", gap:12, position:"sticky", top:0, zIndex:100, boxShadow:"0 2px 16px rgba(30,58,95,0.4)", flexWrap:"wrap" }}>
        <img src="/logo.png" alt="Thoroughbred Vacations" style={{ height:52, width:52, borderRadius:8, objectFit:"cover", flexShrink:0 }} />
        <div style={{ flex:1, minWidth:160 }}>
          <div style={{ color:"#fff", fontWeight:900, fontSize:16, letterSpacing:"0.02em" }}>Thoroughbred Vacations™</div>
          <div style={{ color:"#86efac", fontSize:11, fontStyle:"italic" }}>{trip.name||"Family Travel Command Center"}</div>
        </div>
        <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" }}>
          {trip.name&&<div style={{ background:"rgba(255,255,255,0.15)", color:"#fff", borderRadius:8, padding:"4px 10px", fontSize:12, fontWeight:700 }}>📍 {trip.destination||trip.name}</div>}
          <button onClick={handleExport} style={{ background:saveFlash?"#16A34A":"rgba(255,255,255,0.15)", color:"#fff", border:"1px solid rgba(255,255,255,0.3)", borderRadius:8, padding:"6px 12px", fontSize:12, fontWeight:700, cursor:"pointer", transition:"background 0.3s" }}>
            {saveFlash?"✅ Saved!":"💾 Save Trip"}
          </button>
          <label style={{ background:"rgba(255,255,255,0.15)", color:"#fff", border:"1px solid rgba(255,255,255,0.3)", borderRadius:8, padding:"6px 12px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
            📂 Load Trip <input type="file" accept=".json" onChange={handleImport} style={{ display:"none" }} />
          </label>
          <button onClick={handleNewTrip} style={{ background:"rgba(255,255,255,0.1)", color:"rgba(255,255,255,0.8)", border:"1px solid rgba(255,255,255,0.2)", borderRadius:8, padding:"6px 12px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
            ✨ New Trip
          </button>
          {showInstall&&(
            <button onClick={handleInstall} style={{ background:"#16A34A", color:"#fff", border:"none", borderRadius:8, padding:"6px 12px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
              📲 Install App
            </button>
          )}
        </div>
      </div>
      {/* TAB BAR */}
      <div className="tv-tabbar" style={{ background:"#fff", borderBottom:"1.5px solid #e2e8f0", overflowX:"auto", display:"flex", padding:"0 8px", position:"sticky", top:57, zIndex:99, boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>setActiveTab(t.id)} style={{ padding:"12px 11px", border:"none", background:"none", cursor:"pointer", fontWeight:activeTab===t.id?800:500, color:activeTab===t.id?t.color:"#64748b", fontSize:12, whiteSpace:"nowrap", borderBottom:activeTab===t.id?`3px solid ${t.color}`:"3px solid transparent", fontFamily:"system-ui,sans-serif", transition:"all 0.15s", display:"flex", alignItems:"center", gap:4 }}>
            <span>{t.icon}</span><span>{t.label}</span>
          </button>
        ))}
      </div>
      {/* CONTENT */}
      <div style={{ maxWidth:1080, margin:"0 auto", padding:"24px 20px", minHeight:"calc(100vh - 110px)", background:tab?.light }}>
        {render()}
      </div>
    </div>
  );
}
